export default ({ url, isCurrent, children }) => {
  return <a
    class={`knowledge-base-navigation-link ${isCurrent ? 'knowledge-base-navigation-link--current' : ''}`}
    href={url}
  >
    {children}
  </a>
}
